import User from "./User.js";

class Causer extends User {
  static type = "causer";
}

Causer.define();

export default Causer;
